import type { Map as MapboxMap } from 'mapbox-gl';
import { useEffect } from 'react';

const WATER_BODY_LAYER = 'water-body-definitions fill';

export const useWaterBodyLayers = (map?: MapboxMap) => {
  useEffect(() => {
    if (!map) return;

    try {
      if (map.getLayoutProperty(WATER_BODY_LAYER, 'visibility') !== 'visible') {
        map.setLayoutProperty(WATER_BODY_LAYER, 'visibility', 'visible');
      }
    } catch (e) {
      // Do nothing - layer might not exist yet
    }

    return () => {
      try {
        map.setLayoutProperty(WATER_BODY_LAYER, 'visibility', 'none');
      } catch (e) {
        // Do nothing - layer might not exist anymore
      }
    };
  }, [map]);
};
